var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-tasklists" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "content-wrapper" }, [
          _c("div", { staticClass: "container-wrapper center" }, [
            _c("div", [
              _c(
                "div",
                {
                  staticStyle: { display: "none" },
                  attrs: { id: "userIdWrapper" }
                },
                [_vm._v(_vm._s(_vm.lmsUserId))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { display: "none" },
                  attrs: { id: "pathWrapper" }
                },
                [_vm._v(_vm._s(_vm.dashboardPath))]
              )
            ]),
            _vm._v(" "),
            _vm.courseLaunch == "production"
              ? _c(
                  "div",
                  { staticClass: "pacificblue", attrs: { id: "learnembed" } },
                  [
                    _c("VueScriptComponent", {
                      attrs: {
                        script:
                          '<script type="text/javascript">var user_id = document.getElementById("userIdWrapper").innerText; var partner_id = 146;var language_id = 1;var dashboard_path = document.getElementById("pathWrapper").innerText;</script><script id="course" charset="utf-8" src="https://www.poweredbyu.com/products/learn/embed/course/embed_course.js"></script>'
                      }
                    })
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "pacificblue", attrs: { id: "learnembed" } },
                  [
                    _c("VueScriptComponent", {
                      attrs: {
                        script:
                          '<script type="text/javascript">var user_id = document.getElementById("userIdWrapper").innerText; var partner_id = 146;var language_id = 1;var dashboard_path = document.getElementById("pathWrapper").innerText;</script><script id="course" charset="utf-8" src="https://poweredbyu.uinct.com/products/learn/embed/course/embed_course.js"></script>'
                      }
                    })
                  ],
                  1
                )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11b084ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11b084ef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mentee/course_display.vue
// module id = null
// module chunks = 